import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import IconButtonTsoPq from '@components/Buttons/IconButtonTsoPq';
import { faX } from '@fortawesome/free-solid-svg-icons';
import { Box, ListItem, ListItemText, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

type UploadListTsoPqProps = {
  files: File[];
  removeButton?: boolean;
  removeButtonAction?: (fileToRemove: File) => void;
  error?: boolean;
};

const StyledList = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '40.25rem',
    overflowY: 'auto',

    '& > li': {
      borderRadius: tsoPqTheme.shape.border_radius_tso_border_radius_4,
      color: tsoPqTheme.palette.customTextColor.color_neutral_font_ft_nrtrl_enabled,
    },

    '& > li:nth-of-type(even)': {
      background: tsoPqTheme.palette.background.neutral.color_neutral_background_bg_neutral_lt,
    },
  };
});

const StyledListItem = styled(ListItem)(() => {
  return {
    display: 'flex',
    gap: '1.5rem',
    padding: '0.25rem 1.125rem 0.25rem 0.5rem',

    '& .MuiListItemText-root ': {
      height: '2rem',
      fontFamily: tsoPqTheme.typography.openSans,
      fontWeight: 400,
      fontSize: tsoPqTheme.typography.fontsize_label_label_small,
      lineHeight: tsoPqTheme.typography.lineHeight_s,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      margin: '0',

      '& span': {
        fontSize: tsoPqTheme.typography.fontsize_label_label_small,
      },

      '& p': {
        fontSize: tsoPqTheme.typography.fontsize_label_label_small,
        color: tsoPqTheme.palette.customError.color_signal_error_error,
      },
    },
  };
});

const UploadListTsoPq = ({ files, removeButton, removeButtonAction, error }: UploadListTsoPqProps) => {
  const { t } = useTranslation();

  return (
    <StyledList>
      {files.map((file) => (
        <StyledListItem
          key={`${file.name}_${file.lastModified}`}
          secondaryAction={
            removeButton &&
            removeButtonAction && (
              <IconButtonTsoPq
                sizeVariant="m"
                buttonType="transparentNeutralNoEffect"
                icon={faX}
                onClick={() => {
                  removeButtonAction(file);
                }}
              />
            )
          }
        >
          <ListItemText primary={file.name} secondary={error && t('upload.fileUpload.uploadingFile.error')} />
        </StyledListItem>
      ))}
    </StyledList>
  );
};

export default UploadListTsoPq;
